import { render, staticRenderFns } from "./BaseinfoSetting.vue?vue&type=template&id=1c936465&scoped=true&"
import script from "./BaseinfoSetting.vue?vue&type=script&lang=js&"
export * from "./BaseinfoSetting.vue?vue&type=script&lang=js&"
import style0 from "./BaseinfoSetting.vue?vue&type=style&index=0&id=1c936465&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c936465",
  null
  
)

export default component.exports